import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import ValueProp from "@/components/landing/ValueProp";
import Aviation from "@/components/landing/Aviation";
import Services from "@/components/landing/Services";
import Calculator from "@/components/landing/Calculator";
import About from "@/components/landing/About";
import Process from "@/components/landing/Process";
import Testimonials from "@/components/landing/Testimonials";
import EnquiryForm from "@/components/landing/EnquiryForm";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#04222C] text-slate-100 antialiased overflow-x-clip">
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-[5] opacity-[0.035]"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='160' height='160' filter='url(%23n)'/%3E%3C/svg%3E\")",
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <ValueProp />
        <Aviation />
        <Services />
        <Calculator />
        <About />
        <Process />
        <Testimonials />
        <EnquiryForm />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}
